module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAMAAABo+94fAAAALVBMVEVMaXFPT09PT09RUVFPT09RUVFQUFBRUVFPT09QUFBRUVF/f39QUFBRUVFRUVGiQovSAAAADnRSTlMAMGGgQIB83CDQ6AKuxlz9wmIAAABISURBVHja3c07DsAwCANQkxTI1/c/boamUiRygr7JeDAwXhjoKXCCGUH+Xz0lmMTgxUCXZ3P/kvRjsdbwpJhqa6pWcErc0nsvYZMFb6jvW9oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-screen.png
// module id = q4Cb
// module chunks = 0